import { PaymentResultContract } from 'models'
import { useEffect } from 'react'
import PaymentEvent, {
    PaymentEventType,
} from 'websockets/events/paymentIntegrationEvent'

export const useSalePaymentEventSubscription = (
    onReceiveResponse: (res: PaymentResultContract) => void,
) => {
    useEffect(() => {
        const subscribe = PaymentEvent.subscribe((event) => {
            if (
                event.type ===
                PaymentEventType.OnSalePaymentIntegrationStatusChanged
            )
                onReceiveResponse(event.params)
        })

        return () => {
            subscribe.unsubscribe()
        }
    }, [onReceiveResponse])
}
